<template>
    <div>
        <div class="modal fade" id="signUpModal" tabindex="-1" role="dialog" aria-labelledby="fontModalLabel"
             aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="fontModalLabel">Sign Up</h5>
                        <button type="button" class="btn-close" @click="noHandler" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">

                        <div v-if="errorMessage" class="alert alert-warning" role="alert">
                            {{errorMessage}}
                        </div>

                        <form class="my-1">

                            <div class="mb-3">
                                <label for="user_name">Name</label><br>
                                <input v-model="user.name" autofocus="autofocus" autocomplete="off" class="form-control"
                                       type="text" id="user_name">
                            </div>

                            <div class="mb-3">
                                <label for="user_email">Email</label><br>
                                <input v-model="user.email" autofocus="autofocus" autocomplete="off" class="form-control"
                                       type="email" id="user_email">
                            </div>

                            <div class="mb-3">
                                <label for="user_password">Password</label><br>
                                <input v-model="user.password" autocomplete="off" class="form-control" type="password"
                                       id="user_password">
                            </div>

                        </form>

                        <div>
                            <a href="javascript:void(0)" @click="onSignInClick">Already have an account? Log in.</a>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="onSignupClick">Sign Up</button>
                        <button type="button" class="btn btn-secondary " @click="noHandler">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import UserService from "../services/UserService";

export default {
    name: 'SignUpModal',
    props: {
        yesEvent: Function,
        switchToSignIn: Function
    },
    data() {
        return {
            model: webase.model,
            currentModal: null,
            modalElement: null,
            user: {
                name: '',
                email: '',
                password: '',
                password_confirmation: ''
            },
            errorMessage: null,
        }
    },
    mounted() {
        this.modalElement = document.getElementById('signUpModal')
        this.currentModal = new bootstrap.Modal(this.modalElement)
        this.modalElement.addEventListener('hidden.bs.modal', this.onModalHidden)
        this.currentModal.show()
    },
    beforeUnmount() {
        this.modalElement.removeEventListener('hidden.bs.modal', this.onModalHidden)
    },
    methods: {
        onModalHidden() {
            this.$emit('noEvent')
        },
        noHandler(e) {
            this.currentModal.hide()
        },
        yesHandler(e) {
            // call the parent's "yesEvent"
            if (this.yesEvent) {
                this.yesEvent()
            }

            // hide the modal
            this.noHandler()
        },
        onSignInClick() {
            this.switchToSignIn()
            this.noHandler()
        },
        onSignupClick() {
            let service = new UserService()
            let site = window.location.hostname
            this.user.password_confirmation = this.user.password
            service.signUp(this.user, site).then((response) => {
                this.model.auth_token = response.auth_token
                this.model.user_id = response.id
                this.model.currentUser = response
                this.yesHandler()
            }).catch((error) => {
                this.errorMessage = webase.utils.notification.parseErrorData(error.errors)
            })
        }
    }
}
</script>
